import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import classNames from 'classnames';
import { formatFullNameAndStatus, formatGeneric } from '../../users/usersGridFormatter';
import RemoveTeamMemberButton from '../removeTeamMemberButton';
import styles from './style.scss';

@inject('translationsStore', 'teamMembersStore') @observer
export default class TeamsUsersGrid extends Component {

    formatRemoveMember = (userId) => {

        return <RemoveTeamMemberButton userId={userId} />;
    }

    render(){

        const options = {
            sizePerPage: 11,
            hideSizePerPage: true,
            noDataText: this.props.translationsStore.translate('NO_DATA_TO_DISPLAY'),
        };

        const table = <BootstrapTable
                        data={this.props.teamUsers}
                        options={options}
                        striped
                        hover
                        pagination
                        tableContainerClass={classNames(styles.innerTableContainerWrapper)}
                        bodyContainerClass={classNames(styles.tableBodyWrapper)}
                        headerContainerClass={classNames(styles.innerTabGridHeader)}
                        trClassName='table-row'
                    >                        
                        <TableHeaderColumn dataField='fullName' className='table-header user-full-name-header-column'
                                dataFormat={formatFullNameAndStatus}
                                dataSort >
                            <span className={classNames(styles.memberName)}>
                                {this.props.translationsStore.translate('NAME')}
                            </span>
                        </TableHeaderColumn>

                        <TableHeaderColumn dataField='userName' className='table-header'
                                dataFormat={formatGeneric}
                                dataSort >
                            {this.props.translationsStore.translate('USER_NAME')}
                        </TableHeaderColumn>

                        <TableHeaderColumn dataField='authenticationProvider' className='table-header'
                                dataFormat={formatGeneric}
                                dataSort >
                            {this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                        </TableHeaderColumn>

                        <TableHeaderColumn dataField='email' className='table-header'
                                dataFormat={formatGeneric}
                                dataSort >
                            {this.props.translationsStore.translate('EMAIL')}
                        </TableHeaderColumn>

                        <TableHeaderColumn isKey dataField='id' className='table-header' width='100px'
                                dataFormat={this.formatRemoveMember}>
                        </TableHeaderColumn>
                    </BootstrapTable>;

        return (
            <div>
                <Scrollbars
                    style={{ height: '70vh', width: '100%' }}
                >
                    <div className='portal-light-grid organization-users-grid'
                        style={{height: '63vh'}}
                    >
                        {table}
                    </div>
                </Scrollbars>
            </div>
        );
    }
}